module.exports = __webpack_public_path__ + "img/IMG_0057_L_BlackMatted.a3c3ae8f.jpg";